import React from 'react';
import styled from 'styled-components';
import { color } from 'styles/utils';
import HoverButton from './HoverButton';

interface TextCheckButtonProps {
  children?: React.ReactNode;
  text?: string;
  className?: string;
  active: boolean;
  size?: string;
  width?: string;
  height?: string;
  minHeight?: string;
  marginRight?: number;
  padding?: string;
  onClick: () => void;
}

const TextCheckButton = ({
  children,
  text,
  className,
  active,
  // size = 'medium',
  width: widthProp = '',
  height = '',
  minHeight = '',
  marginRight = 15,
  padding = '9px 15px',
  onClick,
}: TextCheckButtonProps) => {
  const gutter = (marginRight * 2) / 3;
  let width = widthProp ? `calc(${widthProp} - ${gutter}px)` : 'auto ';

  return (
    <StyledTextCheckButton
      className={`${className}`}
      variant="outlined"
      activeColor={active ? color.blue : 'white'}
      borderColor={active ? color.blue : '#b5b7c1'}
      width={width}
      height={height}
      minHeight={minHeight}
      padding={padding}
      marginRight={marginRight}
      onClick={onClick}
    >
      {/* <span className="textCheckButton__check_icon_box">
        <CheckIcon width={8} />
      </span> */}
      {children}
    </StyledTextCheckButton>
  );
};

const StyledTextCheckButton = styled(HoverButton)`
  margin-right: ${({ marginRight }) => marginRight}px;
  width: ${({ width }) => width};
  height: ${({ height }) => !!height && height};
  min-height: ${({ minHeight }) => !!minHeight && minHeight};
  padding: ${({ padding }) => padding};
  font-size: 15px;
  border-radius: 50px;
  overflow: hidden;
  &:last-child {
    margin-right: 0;
  }
  /* .textCheckButton__check_icon_box {
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    width: 1px;
    height: 1px;
    border: 10px solid transparent;
    border-top-color: ${({ borderColor }) => borderColor};
    border-right-color: ${({ borderColor }) => borderColor};
    svg {
      position: absolute;
      bottom: 1px;
      left: 0px;
    }
  } */
`;

export default TextCheckButton;
